import { forwardRef } from 'react';
import { FormattedMessage } from 'react-intl';
import AddPlusIcon from '../../../assets/icons/add-plus.svg?react';
import s from './FacilityButton.module.scss';

interface AddFacilityButtonProps {
  /** click handler function */
  onClick: () => void;
}

/**
 * Add another facility button
 */
const AddFacilityButton = forwardRef<HTMLButtonElement, AddFacilityButtonProps>(
  ({ onClick }, ref) => (
    <button type="button" onClick={onClick} className={s.wrapper} ref={ref}>
      <AddPlusIcon role="presentation" focusable="false" />
      <FormattedMessage id="offerWizard.addAnotherFacility" />
    </button>
  )
);

AddFacilityButton.displayName = 'AddFacilityButton';

export default AddFacilityButton;
